export const SERVICE_COMMAND_KEYS = [
  '!폰',
  '!에타',
  '!카톡',
  '!속마음',
  '!스냅',
] as const

type ServiceCommandKey = (typeof SERVICE_COMMAND_KEYS)[number]
type OfficialCommand = {
  key: ServiceCommandKey
  title: string
  description: string
}

const OFFICIAL_COMMANDS: OfficialCommand[] = [
  {
    key: '!폰',
    title: '폰',
    description: '캐릭터의 잠금화면 · 받은 알림 열람',
  },
  { key: '!에타', title: '에타', description: '익명 게시판의 글 · 댓글 열람' },
  {
    key: '!카톡',
    title: '카톡',
    description: '캐릭터와 다른 사람의 대화 열람',
  },
  {
    key: '!속마음',
    title: '속마음',
    description: '현재 장면의 캐릭터 속마음 열람',
  },
  {
    key: '!스냅',
    title: '스냅',
    description: '캐릭터 초상 기반 현재 장면 생성',
  },
]

/** 작가가 고르는 명령어 — !스냅은 모든 작품에 기본으로 들어가 고르지 않는다 */
export const SELECTABLE_COMMANDS = OFFICIAL_COMMANDS.filter(
  (command) => command.key !== '!스냅'
)

const commands = new Map<string, OfficialCommand>(
  OFFICIAL_COMMANDS.map((command) => [command.key, command])
)
const selectable = new Set<string>(
  SELECTABLE_COMMANDS.map((command) => command.key)
)
export const officialCommand = (key: string) => commands.get(key)
export const normalizeOfficialCommands = (keys: readonly string[]) =>
  [...new Set(keys)].filter((key) => selectable.has(key))
